import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getHomeworks } from "../helper/apicalls/homeworks";
import Homework from "../assets/png/homework.png";
import notAvailable from "../assets/images/notAvalaible.svg";
import GlobalLoader from "../components/GlobalLoader";
import "../styles/Homeworks.scss";

const Homeworks = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [activeTab, setActiveTab] = useState("incomplete");
  const navigate = useNavigate();

  const tabs = [
    { id: "upcoming", label: "Upcoming" },
    { id: "incomplete", label: "Incomplete" },
    { id: "complete", label: "Completed" },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await getHomeworks(activeTab);
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
            ? data.data
            : [];
        setItems(list);
      } catch (e) {
        console.error("Failed to load homeworks:", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [activeTab]);

  const handleCardClick = (hw, idx) => {
    const id = hw?.id || hw?._id || idx + 1;
    if (id) {
      const level = hw?.level || hw?.difficulty || "";

      const isSubmitted =
        hw?.submitted === true ||
        hw?.submission === true ||
        activeTab === "complete";

      if (isSubmitted) {
        const title = hw?.title || hw?.name || `Homework ${idx + 1}`;
        const query = level
          ? `/homework-review?homework_id=${id}&level=${encodeURIComponent(level)}&review=true&title=${encodeURIComponent(title)}`
          : `/homework-review?homework_id=${id}&review=true&title=${encodeURIComponent(title)}`;
        navigate(query);
      } else {
        const query = level
          ? `/test?homework_id=${id}&level=${encodeURIComponent(level)}`
          : `/test?homework_id=${id}`;
        navigate(query);
      }
    }
  };

  return (
    <>
      {loading && <GlobalLoader />}
      <div className="page-container homeworks">
        <div className="homeworks-tabs-container">
          <div className="homeworks-tabs">
            <div
              className="tabs-slider"
              style={{
                left: `calc(${tabs.findIndex((t) => t.id === activeTab) * (100 / tabs.length)}% + 4px)`,
                width: `calc(${100 / tabs.length}% - 8px)`,
              }}
            />
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {items.length === 0 && !loading ? (
          <div className="not-found-container">
            <img
              src={notAvailable}
              alt="No Homework"
              style={{ width: "240px", height: "auto", marginBottom: "16px" }}
            />
            <h3>No Homeworks Found!</h3>
          </div>
        ) : (
          <div className="homeworks-list-wrapper custom-scrollbar">
            <ul className="homeworks-list">
              {items.map((hw, idx) => (
                <li
                  key={hw?.id || idx}
                  className="homework-item"
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardClick(hw, idx)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleCardClick(hw, idx);
                    }
                  }}
                >
                  <img
                    src={Homework}
                    alt="Homework Icon"
                    className="homework-item__icon"
                  />
                  <div className="item-title">
                    {hw?.title || hw?.name || `Homework ${idx + 1}`}
                  </div>
                  {hw?.description && (
                    <div className="item-subtitle">{hw?.description}</div>
                  )}
                  {hw?.deadline && (
                    <div className="item-meta">
                      Deadline: {formatDate(hw?.deadline)}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default Homeworks;
